// Global instance manager - prevents multiple drag instances
let globalActiveInstance = null;
let globalCleanupTimer = null;

export const clearGlobalInstance = () => {
  globalActiveInstance = null;
  if (globalCleanupTimer) {
    clearTimeout(globalCleanupTimer);
    globalCleanupTimer = null;
  }
};

export const setGlobalInstance = (instanceId) => {
  clearGlobalInstance();
  globalActiveInstance = instanceId;
  globalCleanupTimer = setTimeout(() => {
    clearGlobalInstance();
  }, 3000);
};

export const getGlobalInstance = () => globalActiveInstance;
